import React from 'react';

interface StatCardProps { label: string; value: string | number; sub?: string; }

export const StatCard: React.FC<StatCardProps> = ({ label, value, sub }) => (
  <div style={{ background: 'var(--bg2)', borderRadius: 8, padding: '12px 14px' }}>
    <div style={{ fontSize: 11, color: '#888780', marginBottom: 4 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 500 }}>{value}</div>
    {sub && <div style={{ fontSize: 11, color: '#888780', marginTop: 2 }}>{sub}</div>}
  </div>
);
